import ko from './ko'
import en from './en'

// en, de, fr, pt
export default {
  en: en,
  ko : ko,
}
